export default "__VITE_ASSET__Dlc$QrlD__"